export const holdDownsText = {
	addHolddownButton: 'Add holddown',
	tableHeaders: {
		startDate: 'Start date',
		endDate: 'End date',
		driverToReplace: 'Linked driver',
		createdBy: 'Created by',
		created: 'Created',
		note: 'Note',
	},
	actions: {
		edit: 'Edit',
		showWorkAssignments: 'Show work assignments',
		delete: 'Delete',
		moreOptionsAriaLabel: 'More options',
	},
};
